import AppCache from "../Common/AppCache";

/**
 * Org branding (header logo) comes from orgMeta.metaInfo.globalConfig.branding,
 * cached at login. Adding a logo for a new org is a DB-only change - no code edit:
 *
 *   "globalConfig": {
 *     ...
 *     "branding": {
 *       "profileLogo": "https://cdn.example.com/acme.svg",  // top-right slot
 *       "profileLogoWidth": "80px",                         // optional
 *       "profileLogoMaxHeight": "32px",                     // optional, must fit a 48px bar
 *       "headerLogo": "https://cdn.example.com/acme.svg",   // top-left slot
 *       "headerLogoWidth": "121px",                         // optional
 *       "headerLogoBackground": "transparent"               // optional
 *     }
 *   }
 *
 * profileLogo replaces the profile avatar on the right of the app bar (where
 * Vammo/bnext/ckers show theirs); headerLogo replaces the Coulomb logo on the
 * left. Set either, both or neither - each falls back to the legacy hardcoded
 * behaviour on its own.
 *
 * Both are used directly as an <img src>, so they may be absolute URLs
 * (nothing to deploy) or paths served from the frontend's public/ folder.
 */
export const getOrgBranding = () => AppCache.getItem("orgBranding") || {};
